export default class MemberApplicationConfiguration {
    static fromData(data) {
        if (!data) {
            return;
        }

        let configuration = new MemberApplicationConfiguration();

        configuration.active = data.active;

        // Stammdaten
        configuration.askTitle = data.askTitle;
        configuration.titleOptions = data.titleOptions;
        configuration.legalRepresentativeAgeLimit = data.legalRepresentativeAgeLimit;

        // Kontaktdaten
        configuration.askBusinessPhone = data.askBusinessPhone;
        configuration.askBusinessMobile = data.askBusinessMobile;
        configuration.askCompanyName = data.askCompanyName;
        configuration.askCOAddress = data.askCOAddress;
        configuration.countryOptions = data.countryOptions;

        // Vertragsdaten
        configuration.askContractStart = data.askContractStart;
        configuration.askContractStartMandatory = data.askContractStartMandatory;
        configuration.canContractStartBeInPast = data.canContractStartBeInPast;
        configuration.contractStartOnlyMonthly = data.contractStartOnlyMonthly;
        configuration.contractStartOnlyQuarterly = data.contractStartOnlyQuarterly;
        configuration.askDepartments = data.askDepartments;
        configuration.departments = data.departments;
        configuration.askPassiveContractState = data.askPassiveContractState;

        // Zahlungsdaten
        configuration.allowInvoicePayment = data.allowInvoicePayment;
        configuration.allowSEPAPayment = data.allowSEPAPayment;
        configuration.allowPaymentIntervalSelection = data.allowPaymentIntervalSelection;
        configuration.allowMonthlyPaymentInterval = data.allowMonthlyPaymentInterval;
        configuration.allowQuarterlyPaymentInterval = data.allowQuarterlyPaymentInterval;
        configuration.allowYearlyPaymentInterval = data.allowYearlyPaymentInterval;

        // Weitere Informationen
        configuration.allowDataUpload = data.allowDataUpload;
        configuration.dataUploadMandatory = data.dataUploadMandatory;
        configuration.dataUploadDescription = data.dataUploadDescription;
        configuration.askEmergencyContact = data.askEmergencyContact;
        configuration.askAdditionalInformation = data.askAdditionalInformation;
        configuration.recommendedByOptions = data.recommendedByOptions;
        configuration.askFamilyMembers = data.askFamilyMembers;
        configuration.dataProtectionUrl = data.dataProtectionUrl;
        configuration.statuteUrl = data.statuteUrl;
        configuration.contributionRegulationsUrl = data.contributionRegulationsUrl;

        configuration.welcomeIntro = data.welcomeIntro;
        configuration.detailsIntro = data.detailsIntro;
        configuration.contactIntro = data.contactIntro;
        configuration.contractIntro = data.contractIntro;
        configuration.paymentIntro = data.paymentIntro;
        configuration.otherIntro = data.otherIntro;
        configuration.fileUploadIntro = data.fileUploadIntro;

        return configuration;
    }
}
